import styled from "styled-components";

export const FilterContainer = styled.div`
    .title{
        font-size: 14px;
        font-weight: 400;
        color: ${({theme}) => theme.color.textOnBg}
    }
    button{
        font-size: 12px;
        font-weight: 500;
        text-transform: none;
        margin-right: 10px;
    }
    button.MuiButton-contained{
        background: ${({theme}) => theme.color.info};
        color: ${({theme}) => theme.color.textOnBg}
    }
    button.MuiButton-outlined{
        border-color: ${({theme}) => theme.color.info};
        color: ${({theme}) => theme.color.textOnBg};
    }
    .MuiCheckbox-root{
        color: #A0A0A0;
    }
    & .Mui-checked, .MuiCheckbox-indeterminate{
        color: #4CA2A8 !important;
    }
    .childOpt {
        white-space: nowrap; 
        overflow: hidden;    
        text-overflow: ellipsis; 
    }

`;
